import React from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Link} from "react-router-dom";
import api from "../Api";
import Popup from "../components/PopUP";
import {useState} from 'react';


export default function AddSubAdmin() {
    const [toast, setToast] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        sub_admin_role: ''
    });
    const [submitting, setSubmitting] = useState(false);

    // Sub Admin Role options
    // const subAdminRoles = [
    //   { value: 'game_manager', label: 'Game Manager' },
    //   { value: 'operation_manager', label: 'Operation Manager' },
    //   { value: 'content_manager', label: 'Content Manager' },
    //   { value: 'user_manager', label: 'User Manager' },
    //   { value: 'moderator', label: 'Moderator' },
    //   { value: 'manufacturer_manager', label: 'Manufacturer Manager' },
    //   { value: 'aircraft_manager', label: 'Aircraft Manager' }
    // ];

    const subAdminRoles = [
        {value: 'super_admin', label: 'Super Admin'},
        {value: 'content_sub_admin', label: 'Content Sub Admin'},
        {value: 'subscription_sub_admin', label: 'Subscription Sub Admin'}
    ];


    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error for this field when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };


    const validateForm = () => {
        const newErrors = {};

        if (!formData.first_name.trim()) {
            newErrors.first_name = 'First name is required';
        }

        if (!formData.last_name.trim()) {
            newErrors.last_name = 'Last name is required';
        }

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }


        if (!formData.sub_admin_role) {
            newErrors.sub_admin_role = 'Please select a role';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setSubmitting(true);
        setErrors({});

        try {
            console.log("formData ", formData)
            const response = await api.post('/user-service/user/create-sub-admin', formData);
            console.log(response)

            setToast({
                message: 'SubAdmin created successfully!',
                type: 'success'
            });

            // Reset form
            setFormData({
                first_name: '',
                last_name: '',
                email: '',
                sub_admin_role: ''
            });

            // Optional: Redirect after success
            // setTimeout(() => {
            //   navigate('/sub-admin');
            // }, 2000);

        } catch (err) {
            console.error('Error creating subadmin:', err);

            const errorMessage =
                err?.response?.data?.detail ||
                err?.response?.data?.message ||
                "Something went wrong. Please try again.";


            setToast({
                message: errorMessage,
                type: 'danger'
            });

        } finally {
            setSubmitting(false);
        }
    };

    const handleCancel = () => {
        setFormData({
            first_name: '',
            last_name: '',
            email: '',
            sub_admin_role: ''
        });
        setErrors({});
    };

    return (
        <>

            <Sidebar/>
            <div className="main-wrapper">
                <Header/>

                {/* Content */}
                <Popup
                    message={toast?.message}
                    type={toast?.type}
                    onClose={() => setToast(null)}
                    duration={3000}
                />
                <div className="content-wrapper">
                    <section className="main-section spacer-y">
                        <div className="container">
                            <div className="row gy-4">
                                <div className="col-xl-12">
                                    <div className="common_main_bg_wrapper">
                                        <div className="common_main_heading_wrapper">
                                            <div className="vstack">
                                                <nav className="breadcrumb_nav">
                                                    <ul className="breadcrumb mb-0">
                                                        <li className="breadcrumb-item">
                                                            <Link to="/dashboard">Dashboard</Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/challenge-management">
                                                                SubAdmin Management
                                                            </Link>
                                                        </li>
                                                        <li className="breadcrumb-item text-capitalize">
                                                            Add Sub Admin
                                                        </li>
                                                    </ul>
                                                </nav>
                                                <h1>Sub Admin Management</h1>
                                            </div>
                                            <div className="d-flex flex-end">
                                                <Link to="/sub-admin" className="secondary_btn">
                                                    {/* <img
                      src="${process.env.PUBLIC_URL}/assets/images/Frame (19).svg"
                      alt="Manufactuer Management"
                    /> */}
                                                    View All SubAdmin</Link>
                                            </div>
                                        </div>
                                    </div>
                                    {/*  form here  */}
                                    <form onSubmit={handleSubmit}>
                                        <div className="common-outer-card mt-4">
                                            <div className="common_sub_heading_wrapper">
                                                <h2>Add New SubAdmin</h2>
                                            </div>
                                            <div className="common_content_blk">
                                                <div className="row g-4">
                                                    <div className="col-12 col-sm-6 col-md-6">
                                                        <div className="form_field">
                                                            <label>First Name</label>
                                                            <div className="input_field">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter first name"
                                                                    name="first_name"
                                                                    value={formData.first_name}
                                                                    onChange={handleInputChange}
                                                                />
                                                                <span className="error">{errors.first_name}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-sm-6 col-md-6">
                                                        <div className="form_field">
                                                            <label>Last Name</label>
                                                            <div className="input_field">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter last name"
                                                                    name="last_name"
                                                                    value={formData.last_name}
                                                                    onChange={handleInputChange}
                                                                />
                                                                <span className="error">{errors.last_name}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-sm-6 col-md-6">
                                                        <div className="form_field">
                                                            <label>Email Address</label>
                                                            <div className="input_field">
                                                                <input
                                                                    type="email"
                                                                    className="form-control"
                                                                    placeholder="Enter email address"
                                                                    name="email"
                                                                    value={formData.email}
                                                                    onChange={handleInputChange}
                                                                />
                                                                <span className="error">{errors.email}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-sm-6 col-md-6">
                                                        <div className="form_field">
                                                            <label>Sub Admin Role</label>
                                                            <div className="input_field">
                                                                <select
                                                                    className="form-control"
                                                                    name="sub_admin_role"
                                                                    value={formData.sub_admin_role}
                                                                    onChange={handleInputChange}
                                                                >
                                                                    <option value="">Select Role</option>
                                                                    {subAdminRoles.map((role) => (
                                                                        <option key={role.value} value={role.value}>
                                                                            {role.label}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                <span className="error">{errors.sub_admin_role}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="main_action_blk hstack gap-3 justify-content-start">
                                                        <button
                                                            type="button"
                                                            className="bg_primary_outline_btn rounded-pill"
                                                            onClick={handleCancel}
                                                            disabled={submitting}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            className="primary-btn rounded-pill"
                                                            disabled={submitting || loading}
                                                        >
                                                            {submitting ? 'Saving...' : 'Save'}
                                                        </button>
                                                        {errors.submit &&
                                                            <span className="error">{errors.submit}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    )
}